<ng-template #content let-offcanvas>
    <div class="offcanvas-header">
        <div class="container ">
            <div class="row">
                <div class="col-12 col-md-6 offset-md-3 ">
                    <div class="row">
                        <div class="col-10">
                            <div class="text-capitalize h5 text-secondary mt-2 ">
                                Datos del Perfil
                                <span *ngIf="view == 2" class="text-dark"> (Direcciones)</span>
                                <span *ngIf="view == 3" class="text-dark"> (Condición Laboral)</span>
                                <span *ngIf="view == 4" class="text-dark"> (Ingresos Mensuales)</span>
                                <span *ngIf="view == 5" class="text-dark"> (Medios de pago)</span>
                                <span *ngIf="view == 6" class="text-dark"> (Editar Medio de pago)</span>
                                <span *ngIf="view == 7" class="text-dark"> (Datos basicos)</span>


                            </div>
                        </div>
                        <div class="col-2 text-end pt-2">
                            <button type="button" class="btn-close" aria-label="Close" (click)="view == 7 || view == 5 ? offcanvas.dismiss('Cross click') : view > 1 ? view !== 6 ? view = 1 : view = 5 : offcanvas.dismiss('Cross click'); "></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="offcanvas-body">
        <div class=" container">

            <div class="row">
                <div class=" col-12 col-md-6 offset-md-3">

                    <!-- componente inicial -->
                    <app-data-profile  [estatus_approve]="analysis_response" [person]="person" [code_person]="person?.person?.code" *ngIf="view == 1" (resetStatus)="setResetStatus($event)" (changeView)="setChangView($event)"></app-data-profile>

                    <app-payment-method   [estatus_approve]="analysis_response"  [code_person]="person?.person?.code" *ngIf="view == 5" (resetStatus)="setResetStatus($event)" (editView)="editPaymentMethod($event)" (changeView)="setChangView($event)"></app-payment-method>
                    <app-address  [estatus_approve]="analysis_response"  [code_person]="person?.person?.code" *ngIf="view == 2" (resetStatus)="setResetStatus($event)" (changeView)="setChangView($event)"></app-address>
                    <app-working-condition [code_person]="person?.person?.code" *ngIf="view == 3" (resetStatus)="setResetStatus($event)" (changeView)="setChangView($event)"></app-working-condition>
                    <app-income   [code_person]="person?.person?.code" *ngIf="view == 4" (resetStatus)="setResetStatus($event)" (changeView)="setChangView($event)"></app-income>
                    <app-payment-method-edit *ngIf="view == 6" [dataEdit]="current_payment_method_id" (resetStatus)="setResetStatus($event)" (changeView)="setChangView($event)"></app-payment-method-edit>

                    <app-edit-data-base   [estatus_approve]="analysis_response"  [person]="person" [code_person]="person?.person?.code" *ngIf="view == 7" (resetStatus)="setResetStatus($event)" (editView)="editBaseData($event)" (changeView)="setChangViewPerson($event)"></app-edit-data-base>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #content2 let-offcanvas>
    <div class="offcanvas-header">
        <div class="container ">
            <div class="row">
                <div class="col-12 col-md-6 offset-md-3 ">
                    <div class="row">
                        <div class="col-10">
                            <div class="text-capitalize h5 text-secondary mt-2 ">
                                Detalles de aprobación

                            </div>
                        </div>
                        <div class="col-2 text-end pt-2">
                            <button type="button" class="btn-close" aria-label="Close" (click)=" view > 1 ? view !== 6?view = 1: view = 5 : offcanvas.dismiss('Cross click'); "></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="offcanvas-body">
        <div class=" container">

            <div class="row">
                <div class=" col-12 col-md-6 offset-md-3">

                    <div *ngFor="let item of approve_type_person" class="approval-card mt-4"
                         [class.approval-card-mt]="getMotorIdentity(item).key === 'mt'"
                         [class.approval-card-credolab]="getMotorIdentity(item).key === 'credolab'"
                         [class.approval-card-other]="getMotorIdentity(item).key !== 'mt' && getMotorIdentity(item).key !== 'credolab'"
                         [class.approval-card-decisive]="item?.isDecisive">

                        <!-- Banner decisivo -->
                        <div class="approval-card-decisive-banner" *ngIf="item?.isDecisive">
                            <i class="fas fa-gavel me-1"></i>
                            Esta evaluación determinó el resultado final
                        </div>

                        <div>
                            <div class="float-end text-end">
                                <span class="badge bg-purple-decisive text-white small me-1" *ngIf="item?.isDecisive">
                                    <i class="fas fa-gavel me-1"></i> Decisivo
                                </span>
                                <span class="badge bg-warning text-dark small me-1" *ngIf="item?.fallbackUsed">
                                    <i class="fas fa-exclamation-triangle me-1"></i> Fallback
                                </span>
                                <span class="badge bg-light text-dark small me-1"
                                      *ngIf="item?.policyModeAtDecision"
                                      [title]="getPolicyModeTooltip(item.policyModeAtDecision)">
                                    <i class="fas fa-info-circle small me-1"></i>
                                    {{ getPolicyModeLabel(item.policyModeAtDecision) }}
                                </span>
                                <span class="badge bg-light text-dark small me-1" *ngIf="getExecutionOrder(item)">
                                    <i class="fas fa-hashtag"></i> {{ getExecutionOrderLabel(item) }}
                                </span>
                                <span [class.text-success]="item?.approve_status == 'APPROVED'"
                                      [class.text-danger]="item?.approve_status == 'REFUSED'"
                                      [class.text-warning]="item?.approve_status == 'PENDING'"
                                      [class.text-secondary]="item?.approve_status != 'APPROVED' && item?.approve_status != 'REFUSED' && item?.approve_status != 'PENDING'">
                                    {{ getApprovalStatusLabel(item?.approve_status) }}
                                </span>
                            </div>

                            <div class="fw-bold approval-card-title">
                                <i class="fas {{ getMotorIdentity(item).icon }} me-2"></i>
                                {{ getMotorIdentity(item).title }}
                            </div>
                            <div class="small text-muted" *ngIf="getMotorIdentity(item).subtitle">
                                {{ getMotorIdentity(item).subtitle }}
                            </div>

                        </div>

                        <div class="small">

                            <div class="" > {{ item?.date | date:'dd MMM yyyy, HH:mm':undefined:'es' }}</div>

                        </div>

                        <div class="mt-1 small text-secondary" *ngIf="item?.approve_type?.name  == 'BURO'">
                            Puntaje :
                            <span *ngIf="item.response?.puntaje"> {{item.response?.puntaje}} </span>
                            <span *ngIf="item.response?.Informe?.Score?.dolar?.puntaje"> {{item.response?.Informe?.Score?.dolar?.puntaje}} </span>

                        </div>

                        <div class="mt-1 " *ngIf="item?.approve_type?.name  == 'MANUAL_SYSTEM'">
                            <div class="text-dark mt-2 small" >Responsable: {{item?.executiveFullName}} </div>

                            <div  *ngIf="item.response?.description" >Descripción: {{item.response?.description}} </div>

                        </div>

                        <div class="mt-1 " *ngIf="item?.approve_type?.name  == 'IDENTITY_DATA_COMPARISON'">

                            <div  *ngIf="item.response?.biometricRefusedMsg" >{{item.response?.biometricRefusedMsg}} </div>

                        </div>

                        <!-- MUNDO_TOTAL_SCORE -->
                        <div class="mt-2 small" *ngIf="item?.approve_type_name == 'MUNDO_TOTAL_SCORE'">
                            <div *ngIf="item?.approve_status == 'REFUSED' && hasMotivo(item)" class="alert alert-danger py-2 px-3 mb-0 small">
                                <strong>Motivo: </strong>{{ getMtMotivoLabel(item.response?.motivo_rechazo ?? item.response?.customer_data?.motivo_rechazo) }}
                            </div>
                        </div>

                        <!-- CREDOLAB_SCORING -->
                        <div class="mt-2 small" *ngIf="item?.approve_type_name == 'CREDOLAB_SCORING'">
                            <div class="row">
                                <div class="col-12"><strong>Referencia:</strong> <code>{{item.response?.referenceNumber ?? '—'}}</code></div>
                            </div>

                            <!-- Modelos de score: se listan todos los que trajo el upload
                                 (score_v2 y score). El que decidió lleva el sello. -->
                            <div class="mt-3" *ngFor="let m of getCredolabModels(item)">
                                <div class="small d-flex align-items-center mb-1">
                                    <span class="fw-medium">{{ m.label }}</span>
                                    <span class="badge bg-purple-decisive text-white small ms-2" *ngIf="m.decided">
                                        <i class="fas fa-gavel me-1"></i> Decidió
                                    </span>
                                    <span class="text-muted ms-2" *ngIf="!m.decided">solo referencia</span>
                                    <span class="ms-auto" *ngIf="m.passed !== null"
                                          [class.text-success]="m.passed" [class.text-danger]="!m.passed">
                                        <i class="fas" [class.fa-check]="m.passed" [class.fa-times]="!m.passed"></i>
                                        {{ m.passed ? 'pasa' : 'no pasa' }}<span *ngIf="m.minScore !== null"> (mín. {{ m.minScore }})</span>
                                    </span>
                                </div>
                                <div class="row g-2">
                                    <div class="col-6">
                                        <div class="credolab-metric-card">
                                            <div class="credolab-metric-label">SCORE</div>
                                            <div class="credolab-metric-value">{{ m.score ?? '—' }}</div>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="credolab-metric-card">
                                            <div class="credolab-metric-label">PROB. DEFAULT</div>
                                            <div class="credolab-metric-value">
                                                {{ m.probability != null ? (m.probability | percent:'1.2-2') : '—' }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Alertas conductuales: usa highRiskCount persistido en derived (Bloque 2.8C) -->
                            <div class="mt-3" *ngIf="item.response?.derived">
                                <ng-container *ngIf="item.response.derived.highRiskCount === 0; else hasAlerts">
                                    <div class="credolab-alert-ok small">
                                        <i class="fas fa-check-circle me-2"></i> Sin alertas conductuales detectadas
                                    </div>
                                </ng-container>
                                <ng-template #hasAlerts>
                                    <details class="credolab-alert-warn">
                                        <summary class="small">
                                            <i class="fas fa-exclamation-triangle me-2"></i>
                                            {{ item.response.derived.highRiskCount }} alerta{{ item.response.derived.highRiskCount === 1 ? '' : 's' }} conductual{{ item.response.derived.highRiskCount === 1 ? '' : 'es' }} detectada{{ item.response.derived.highRiskCount === 1 ? '' : 's' }}
                                            <span class="text-muted ms-2">(ver detalle)</span>
                                        </summary>
                                        <div class="mt-2 small">
                                            <div *ngFor="let code of item.response.derived.highRiskFlags" class="credolab-alert-item">
                                                <i class="fas fa-dot-circle me-2"></i>
                                                {{ getFlagLabel(code) }}
                                                <code class="text-muted ms-2">{{ code }}</code>
                                            </div>
                                        </div>
                                    </details>
                                </ng-template>
                            </div>

                            <div class="mt-2" *ngIf="hasMotivo(item)">
                                <div class="alert py-2 px-3 mb-0 small"
                                     [class.alert-success]="item?.approve_status == 'APPROVED'"
                                     [class.alert-danger]="item?.approve_status == 'REFUSED'">
                                    <strong>Motivo: </strong>{{ getCredolabDecisionLabel(item?.description) }}
                                </div>
                            </div>

                            <div class="mt-3" *ngIf="item?.approve_status == 'REFUSED' && getCredolabTriggeredFlags(item?.description)?.length">
                                <div class="small text-danger fw-medium mb-1">
                                    <i class="fas fa-ban me-2"></i>
                                    {{ getCredolabTriggeredFlags(item?.description)?.length }} flag(s) dispararon auto-rechazo:
                                </div>
                                <div class="small">
                                    <span *ngFor="let flag of getCredolabTriggeredFlags(item?.description); let last = last">
                                        {{ getFlagLabel(flag) }}<span *ngIf="!last">, </span>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <!-- Visor JSON crudo -->
                        <details class="approval-json-viewer mt-3"
                                 *ngIf="item?.response && item?.approve_type_name != 'MUNDO_TOTAL_SCORE'">
                            <summary class="small text-muted">
                                <i class="fas fa-code me-1"></i> Ver respuesta completa (JSON)
                                <button class="btn btn-sm btn-link py-0 px-2 ms-2"
                                        (click)="copyResponseJson($event, item.response)"
                                        title="Copiar al portapapeles">
                                    <i class="fas fa-copy"></i>
                                </button>
                            </summary>
                            <pre class="approval-json-pre mt-2">{{ item.response | json }}</pre>
                        </details>

                    </div>

                </div>
            </div>
        </div>
    </div>
</ng-template>



<ng-template #content3 let-offcanvas>
    <div class="offcanvas-header">
        <div class="container ">
            <div class="row">
                <div class="col-12 ">
                    <div class="row">
                        <div class="col-10">
                            <div class="text-capitalize h5 text-secondary mt-2 ">

                            </div>
                        </div>
                        <div class="col-2 text-end pt-2">
                            <button type="button" class="btn-close" aria-label="Close" (click)=" view > 1 ? view !== 6?view = 1: view = 5 : offcanvas.dismiss('Cross click'); "></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="offcanvas-body mb-3">
        <div class=" container pb-5">

            <ng-container *ngIf="!loading_bio">

            <!-- PRE-REGISTRO -->
            <div class="d-flex justify-content-between align-items-center">
                <div class="h5 text-secondary mt-2">Pre-registro</div>
                <button 
                    *ngIf="!editingBirthDate && _auth.hasPermission('contactos.onboarding.editar_fecha')"
                    class="btn btn-sm btn-outline-primary"
                    (click)="startEditingBirthDate()">
                    <i class="fas fa-edit me-1"></i> Editar Fecha
                </button>
            </div>

            <div class="row p-3 mt-4" style="border: 1px solid #ccc;">
                <div class="col-12">

                    <!-- Modo Vista -->
                    <div *ngIf="!editingBirthDate">
                        <p class="card-text"> 
                            <span class="text-capitalize fw-bold">{{person?.person?.name}} {{person?.person?.lastName}}</span> 
                            <br>{{getIdentity(person)}}
                            <br>{{person?.person?.gender == 'M'?'Masculino':'Femenino'}}   
                            <br>Fecha de nacimiento: {{person?.person?.birth_date | date: 'dd/MM/yyyy'}}
                            <br>{{ person.person.marital_status.name }}
                        </p>
                    </div>

                    <!-- Modo Edición -->
                    <div *ngIf="editingBirthDate">
                        <p class="card-text mb-3"> 
                            <span class="text-capitalize fw-bold">{{person?.person?.name}} {{person?.person?.lastName}}</span> 
                            <br>{{getIdentity(person)}}
                            <br>{{person?.person?.gender == 'M'?'Masculino':'Femenino'}}
                            <br>{{ person.person.marital_status.name }}
                        </p>

                        <div class="mb-3">
                            <label class="form-label fw-bold">
                                <i class="fas fa-calendar-alt me-2"></i>Fecha de Nacimiento
                            </label>
                            
                            <!-- Date Picker Mobile -->
                            <div class="d-block d-md-none">
                                <mbsc-date 
                                    (onSet)="onBirthDateSet($event)" 
                                    [(ngModel)]="birthDateEdit" 
                                    [options]="mobileSettings" 
                                    placeholder="dd/mm/aaaa">
                                </mbsc-date>
                            </div>
                            
                            <!-- Date Picker Desktop -->
                            <div class="d-none d-md-block">
                                <mbsc-date 
                                    (onSet)="onBirthDateSet($event)" 
                                    [(ngModel)]="birthDateEdit" 
                                    [options]="desktopSettings" 
                                    placeholder="dd/mm/aaaa">
                                </mbsc-date>
                            </div>
                        </div>

                        <div class="d-flex gap-2 justify-content-end">
                            <button 
                                class="btn btn-sm btn-outline-secondary"
                                (click)="cancelEditingBirthDate()"
                                [disabled]="savingBirthDate">
                                <i class="fas fa-times me-1"></i> Cancelar
                            </button>
                            <button 
                                class="btn btn-sm btn-primary"
                                (click)="saveBirthDate()"
                                [disabled]="savingBirthDate || !birthDateEditString">
                                <span *ngIf="!savingBirthDate">
                                    <i class="fas fa-save me-1"></i> Guardar
                                </span>
                                <span *ngIf="savingBirthDate">
                                    <span class="spinner-border spinner-border-sm me-1" role="status"></span>
                                    Guardando...
                                </span>
                            </button>
                        </div>
                    </div>

                </div>
            </div>

            <!-- BIOMETRÍA -->
            <div class="d-flex justify-content-between mt-5">
                <div class="d-flex justify-content-between align-items-center">
                <div class="h5 text-secondary">Biometria</div>
                <div *ngIf="!loadingBiometric && section_transaction && person?.person && biometria_data?.person?.person_customer?.biometric_enabled">
                    <span class="badge bg-warning text-dark p-2 ms-3 mb-1">Biometría Habilitada</span>
                </div>
                </div>
                <div class="d-flex justify-content-between">
                <button [disabled]="biometria_data?.person?.person_customer?.biometric_enabled" class="btn btn-primary mb-4" *ngIf="_auth.hasPermission('contactos.onboarding.habilitar_biometria')" (click)="enableBiometric(person?.person.code)">Habilitar biometría</button>
                <div *ngIf="loadingBiometric" class="ms-2">
                        <div class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">Cargando...</span>
                        </div>
                </div>
                </div>
            </div>

            <div class="row p-3 mt-3" style="border: 1px solid #ccc; border-radius: 8px;">

                <!-- Datos de OCR del Documento -->
                <div class="col-md-4 mt-4 col-12 text-start">
                    <div class="pb-1 fw-bold mb-3">Datos del Documento (OCR)</div>
                    <p class="card-text">
                        <span class="text-capitalize fw-bold">
                            {{ biometria_data?.person_biometric?.ocr_data?.givenNames}}
                            {{ biometria_data?.person_biometric?.ocr_data?.surname}}
                        </span>
                        <br>{{ biometria_data?.person_biometric?.ocr_data?.documentNumber}}
                        <br>Fecha de nacimiento: {{biometria_data?.person_biometric?.ocr_data?.dateOfBirth}}
                        <br>{{biometria_data?.person_biometric?.ocr_data?.maritalStatus}}
                        <br>
                        <span *ngIf="biometria_data?.person_biometric?.ocr_data?.dateOfIssue">
                            Fecha de Expedición: {{biometria_data?.person_biometric?.ocr_data?.dateOfIssue}}
                        </span>
                        <br *ngIf="biometria_data?.person_biometric?.ocr_data?.dateOfIssue">
                        <span *ngIf="biometria_data?.person_biometric?.ocr_data?.dateOfExpiry">
                            Fecha de Expiración: {{biometria_data?.person_biometric?.ocr_data?.dateOfExpiry}}
                        </span>
                    </p>
                </div>

                <div class="col-md-4  mt-4 col-12 text-center" >
                    <div class="pb-1 fw-bold">Documento de Identidad</div>
                    <div class="pb-3"><span class="text-secondary" *ngIf="biometria_data?.person?.file_identity?.date">Fecha: </span>{{biometria_data?.person?.file_identity?.date | date: 'dd/MM/yyyy h:mm:ss a'}}</div>
                    <img  class="w-100  "  *ngIf=" biometria_data?.person?.file_identity" [src]="sanitize( biometria_data?.person?.file_identity?.url)">

                    <span *ngIf="!biometria_data?.person?.file_identity && !loading"> No se encontro documento
                    <!-- agregar el boton y pasar param -->
                    <button *ngIf="ciClickCounter < 3" class="btn" (click)="refreshBiometricPhoto(biometria_data?.person.code, 'CI')">
                            <i class="fas fa-sync-alt text-primary"></i>
                        </button>
                    </span>
                    <div *ngIf="showCiMsg" class="text-danger mt-2">
                        TrustX no está retornando la imagen, por favor contacte a un admin.
                    </div>
                    <div *ngIf="loading" class="mt-2">
                        <div class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">Cargando...</span>
                        </div>
                    </div>
                </div>

                <div class="col-md-4  mt-4  col-12 text-center">
                    <div class="pb-1 fw-bold">Selfie</div>
                    <div class="pb-2"><span class="text-secondary" *ngIf="biometria_data?.person?.file_selfie?.date">Fecha: </span>{{biometria_data?.person?.file_selfie?.date | date: 'dd/MM/yyyy h:mm:ss a'}}</div>
                    <img *ngIf=" biometria_data?.person?.file_selfie"  style="width: 50%;" [src]="sanitize( biometria_data?.person?.file_selfie?.url)">
                    <span *ngIf="!biometria_data?.person?.file_selfie && !loading_img"> No se encontro selfie
                        <!-- agregar el boton y pasar param -->
                        <button class="btn" (click)="refreshBiometricPhoto(biometria_data?.person.code, 'SELFIE')">
                            <i class="fas fa-sync-alt text-primary"></i>
                        </button>
                        <!-- <button *ngIf="!biometria_data?.person?.file_identity && !biometria_data?.person?.file_selfie" class="btn btn-primary mx-3" (click)="refreshBiometricPhoto(biometria_data?.person.code, '')">
                            Refrescar todas
                        </button> -->
                    </span>
                    <div *ngIf="showSelfieMsg" class="text-danger mt-2">
                        TrustX no está retornando la imagen, por favor contacte a un admin.
                    </div>
                    <div *ngIf="loading_img" class="mt-2">
                        <div class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">Cargando...</span>
                        </div>
                    </div>
                </div>



                <div class="col-12 h5 mt-5">

                    <button class="btn p-0" (click)="refreshBiometricStatus(biometria_data?.person.code)" *ngIf="!(declinedStatus || approvedStatus || abandonedStatus || biometria_data?.person?.person_customer?.biometric_enabled)">
                        <i *ngIf="!statusLoading" class="fas fa-sync-alt text-primary me-2"></i>
                        <div *ngIf="statusLoading" class="mt-2">
                        <div class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">Cargando...</span>
                        </div>
                    </div>
                    </button>
                    <span class="text-secondary">Estatus: </span>
                    <span>{{biometria_data?.person_biometric?.status}} </span>
                    <div *ngIf="showStatusMsg" class="text-danger mt-2 h6 mb-2">No hay actualización de estatus en TrustX</div>
                    <div class="h6">{{biometria_data?.person_biometric?.refused_msg}}</div>

                </div>


                <div class="col-12 ">
                    <span class="text-secondary">Instancia: </span>
                    <span class="text-primary cursor-pounter" (click)="redirectIMG(biometria_data?.person_biometric?.url)" >{{biometria_data?.person_biometric?.process_instance_id}} </span>

                </div>


                <div class="col-12 ">
                  <span class="text-secondary">Biometria: </span>
                  <span *ngIf="!biometria_data?.person_biometric?.biometrics_app">(TrustX)</span>
                  <span *ngIf="biometria_data?.person_biometric?.biometrics_app">({{biometria_data?.person_biometric?.biometrics_app}})</span>
                </div>

                <div class="col-12 ">
                    <span class="text-secondary">Fecha: </span>
                    <span>     {{biometria_data?.person_biometric?.update_date | date: 'dd/MM/yyyy h:mm:ss a'}}
                    </span>

                </div>



            </div>

        </ng-container>


        <ng-container *ngIf="!loading_bio_h">

            <div class="h5 text-secondary mt-5"> Historial de Biometria</div>

            <div class=" row p-3 mt-4" style="border: 1px solid #ccc;">
                <div class=" col-12  "   *ngFor="let item of biometrics_h; let i=index">

                    <div class="mb-2">

                      <span class="text-gray-500" *ngIf="!item?.biometrics_app">(TrustX)</span>
                      <span class="text-gray-500" *ngIf="item?.biometrics_app">({{item?.biometrics_app}})</span>

                        <span>     {{item?.entryDate | date: 'dd/MM/yyyy h:mm:ss a'}}
                        </span>
                        <span class="text-primary cursor-pounter pe-2" (click)="redirectIMG(item?.url)" >{{item?.processInstanceId}} </span>

                    </div>

                </div>

                  <span class="text-2xl text-gray-700" *ngIf="biometrics_h?.length == 0">Este usuario no posee historial de biometria.</span>

            </div>
        </ng-container>

        <ng-container *ngIf="_auth.hasAccessOrProfile('contactos', ['OWNER'])">

            <div *ngIf="manual_verification_list" class="h5 text-secondary mt-5">

                Validaciones

            </div>

            <!-- <pre>{{manual_verification_list | json}}</pre> -->


        <div *ngIf="manual_verification_list" class="pb-5">

            <div class="fw-bold">
                {{manual_verification_list?.user?.name}} {{manual_verification_list?.user?.lastName}}

            </div>
                <div class="d-flex mt-2" *ngIf="!_auth.hasRbac$.getValue() || _auth.hasPermission('contactos.onboarding.verificar_biometria')">
                    <button *ngIf="manual_verification_list.verified === false" type="button" class="btn btn-primary  mb-3 me-2 " [disabled]="loading_mv" (click)="setManual_verification(true)">Si, verificar </button>
                    <button *ngIf="manual_verification_list.verified === true" type="button" class="btn btn-danger  mb-3" [disabled]="loading_mv"  (click)="setManual_verification(false)" >No, verificar</button>
                </div>

                <div (click)="verifyHistory()">
                  <span class="text-primary" style="cursor: pointer;">{{history ? 'Ocultar' : 'Ver'}} historial</span>
                </div>

                <div *ngIf="history" class="mt-2">
                  <div class="overflow-auto" style="max-height: 200px;">
                      <div *ngFor="let item of historyList">
                          <span>Respuesta: {{item.verified ? 'Verificado' : 'No verificado'}}</span><br>
                          <span>Fecha: {{item.date | date: 'dd/MM/yyyy h:mm:ss a'}}</span><br>
                          <span>Descripción: {{item.refused_msg}}</span><br>
                          <span>Nombre: {{item.user.name}} {{item.user.lastName}}</span><hr>
                      </div>
                  </div>
              </div>


         <!-- <pre>{{ manual_verification_list | json }}</pre>-->
        </div>


        <div>
            <div class="  row col-12" *ngIf="showButtons">
            <div class=" row p-3 mt-4" style="border: 1px solid #ccc;" *ngIf="inReview || declinedStatus">


                    <div class="mb-2 float-end d-flex justify-content-between">

                       Verificacion de Identidad
                       <div *ngIf="!_auth.hasRbac$.getValue() || _auth.hasPermission('contactos.onboarding.verificar_biometria')">
                        <button *ngIf="!manual_verification_list" type="button" class="btn btn-primary  mb-3 me-2 " [disabled]="loading_mv" (click)="setManual_verification(true)">Si, verificar</button>
                        <button *ngIf="!manual_verification_list" type="button" class="btn btn-danger  mb-3" [disabled]="loading_mv"  (click)="setManual_verification(false)" >No, verificar</button>
                       </div>
                    </div>




                </div>


            </div>
            </div>
        </ng-container>






        <ng-container *ngIf="loading_bio || loading_bio_h">
            <div class="w-100 text-center mt-2">
                <img src="./assets/public/images/loading.gif  " alt=" ">
            </div>
        </ng-container>



        </div>
    </div>
</ng-template>



<ng-template #contentSelfie let-offcanvas>
  <div class="text-end mt-10 mr-4 md:mr-14">
    <button type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click');"></button>
  </div>

  <div class="flex justify-center md:justify-start mb-4 md:ml-32">
    <button type="button" (click)="redirectIMG(person?.person?.file_selfie?.url)" class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">Descargar selfie</button>
  </div>

  <div class="flex items-center justify-center md:justify-center h-auto">
    <div class="bg-gray-50 rounded-lg shadow-md p-4 md:max-w-[300px]" style="max-width: 500px;">
      <img src="{{person?.person?.file_selfie?.url}}" class="w-full h-auto" style="height: 300px; object-fit: cover; border-radius: 8px;">
    </div>
  </div>

</ng-template>



<ng-template #contentIdentity let-offcanvas>
  <div class="text-end mt-10 mr-4 md:mr-14">
    <button type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click');"></button>
  </div>

  <div class="flex justify-center md:justify-start mb-4 md:ml-32">
    <button type="button" (click)="redirectIMG(person?.person?.file_identity?.url)" class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">Descargar cédula</button>
  </div>

  <div class="flex items-center justify-center md:justify-center h-auto">
    <div class="bg-gray-50 rounded-lg shadow-md p-4 md:max-w-[300px]" style="max-width: 500px;">
      <img src="{{person?.person?.file_identity?.url}}" class="w-full h-auto" style="height: 300px; object-fit: cover; border-radius: 8px;">
    </div>
  </div>

</ng-template>



<!-- New Modern Header Section -->
<div class="min-h-screen bg-gray-50 py-8">
    <div class="max-w-6xl mx-auto px-4">

        <!-- Customer Profile Section -->
        <div *ngIf="!loading && person?.person" class="mb-6">
            <div class="bg-white rounded-lg p-6 shadow-sm border border-gray-200">
                        <div class="flex items-center space-x-4 hover:opacity-80 transition-opacity">
                    <div class="flex-shrink-0 cursor-pointer" [routerLink]="['/console/person/profile/',person?.person?.code]">
                        <img
                             *ngIf="person?.person?.file_selfie"
                            class="w-16 h-16 rounded-full object-cover border-2 border-blue-600"
                            [src]="sanitize(person?.person?.file_selfie?.url)"
                            alt="Avatar del cliente"
                        />
                        <img
                            *ngIf="!person?.person?.file_selfie && person?.person?.gender != 'F'"
                            class="w-16 h-16 rounded-full object-cover border-2 border-blue-600"
                            [src]="sanitize('../assets/public/images/avatar.png')"
                            alt="Avatar del cliente"
                        />
                        <img
                            *ngIf="!person?.person?.file_selfie && person?.person?.gender == 'F'"
                            class="w-16 h-16 rounded-full object-cover border-2 border-blue-600"
                            [src]="sanitize('../assets/public/images/avatara-female.png')"
                            alt="Avatar del cliente"
                        />
                        </div>
                    <div class="flex-1">
                        <h2 class="text-xl font-bold text-gray-900 capitalize hover:text-blue-600 transition-colors">
                                {{person?.person?.name}} {{person?.person?.lastName}}
                            </h2>
                        <div class="flex flex-wrap gap-4 mt-1 text-sm text-gray-600">
                            <div class="flex items-center gap-1">
                                <i class="fas fa-id-card text-blue-600"></i>
                                <span class="cursor-pointer hover:text-blue-600 transition-colors" 
                                      (click)="copyIdentityToClipboard(person)"
                                      title="Clic para copiar">{{getIdentity(person)}}</span>
                            </div>
                            <div class="flex items-center gap-1">
                                <i class="fas fa-phone text-blue-600"></i>
                                <span class="cursor-pointer hover:text-blue-600 transition-colors" 
                                      (click)="copyPhoneToClipboard(person)"
                                      title="Clic para copiar">{{getContact(person)}}</span>
                            </div>
                            <div *ngIf="getEmailContact(person)" class="flex items-center gap-1">
                                <i class="fas fa-envelope text-blue-600"></i>
                                <span>{{getEmailContact(person)}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Loading State -->
        <div *ngIf="loading" class="text-center py-12">
            <div class="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mb-4"></div>
            <p class="text-gray-600">Cargando información...</p>
        </div>

        <!-- Onboarding Steps Content -->
        <div class="space-y-6">
            <ng-container *ngIf="shouldShowProgressSection()">

                <div class="onboarding-grid" *ngIf="hasSectionData()">

                    <!-- Pre-Registro -->
                    <div class="onboarding-step-card completed" *ngFor="let item of section_transactions; let i = index">

                        <!-- Pre-Registro Card -->
                        <div *ngIf="item?.code == 'PRE_REGISTER'" class="step-card completed">
                            <div class="step-header">
                                <div class="step-icon">
                                    <i class="fas fa-user-plus"></i>
                                </div>
                                <div class="step-info">
                                    <h6 class="step-title">{{item.name}}</h6>
                                    <span class="step-status completed">Completado</span>
                                </div>
                                <div class="step-actions">
                                    <i class="fas fa-check-circle status-icon completed"></i>
                                </div>
                            </div>
                            <div class="step-details">
                                <div class="detail-item">
                                    <i class="fas fa-calendar"></i>
                                    <span>Fecha: {{section_transaction?.PRE_REGISTER?.date | date: 'dd/MM/yyyy'}}</span>
                                </div>
                            </div>
                        </div>

                        <!-- Términos y Condiciones Card -->
                        <div *ngIf="item?.code == 'TERMS_AND_CONDITIONS'" class="step-card completed">
                            <div class="step-header">
                                <div class="step-icon">
                                    <i class="fas fa-file-contract"></i>
                                </div>
                                <div class="step-info">
                                    <h6 class="step-title">{{item.name}}</h6>
                                    <span class="step-status completed">Completado</span>
                                </div>
                                <div class="step-actions">
                                    <i class="fas fa-check-circle status-icon completed"></i>
                                </div>
                            </div>
                            <div class="step-details" *ngIf="person?.person?.date_response_terms_and_conditions">
                                <div class="detail-item">
                                    <i class="fas fa-calendar-check"></i>
                                    <span>Aprobado: {{person?.person?.date_response_terms_and_conditions | date: 'dd/MM/yyyy'}}</span>
                                </div>
                            </div>
                        </div>

                        <!-- Datos Personales Card -->
                        <div *ngIf="item?.code == 'PROFILE_DATA'" class="step-card" [class.completed]="isProfileDataComplete()" [class.pending]="!isProfileDataComplete()" [class.expandable]="true">
                            <div class="step-header" (click)="toggleStepExpansion('profile_data')">
                                <div class="step-icon">
                                    <i class="fas fa-user-edit"></i>
                                </div>
                                <div class="step-info">
                                    <h6 class="step-title">{{item.name}}</h6>
                                    <span class="step-status" [class.completed]="isProfileDataComplete()" [class.pending]="!isProfileDataComplete()">{{getProfileDataStatus()}}</span>
                                </div>
                                <div class="step-actions">
                                    <button class="action-btn primary" *ngIf="_auth.hasPermission('contactos.onboarding.read')" (click)="openProfileDataModal(); $event.stopPropagation()">
                                        <i class="fas fa-eye"></i> Ver
                                    </button>
                                    <i [class]="getProfileDataStatusIcon()"></i>
                                    <i class="fas fa-chevron-down expand-icon" [class.rotated]="expandedSteps['profile_data']"></i>
                                </div>
                            </div>

                            <!-- Subsecciones expandibles -->
                            <div class="step-subsections" [class.expanded]="expandedSteps['profile_data']">
                                <div class="subsection-item" [class.completed]="true">
                                    <i class="fas fa-check-circle subsection-icon"></i>
                                    <span>Datos básicos</span>
                                    <button class="subsection-action" *ngIf="_auth.hasPermission('contactos.onboarding.editar_datos')" (click)="editBasicData()">
                                        <i class="fas fa-edit"></i>
                                    </button>
                                </div>
                                <div class="subsection-item" [class.completed]="hasAddresses()">
                                    <i class="fas fa-check-circle subsection-icon" *ngIf="hasAddresses()"></i>
                                    <i class="fas fa-clock subsection-icon pending" *ngIf="!hasAddresses()"></i>
                                    <span>Direcciones</span>
                                </div>
                                <div class="subsection-item" [class.completed]="hasWorkingCondition()">
                                    <i class="fas fa-check-circle subsection-icon" *ngIf="hasWorkingCondition()"></i>
                                    <i class="fas fa-clock subsection-icon pending" *ngIf="!hasWorkingCondition()"></i>
                                    <span>Condición laboral</span>
                                </div>
                                <div class="subsection-item" [class.completed]="hasIncome()">
                                    <i class="fas fa-check-circle subsection-icon" *ngIf="hasIncome()"></i>
                                    <i class="fas fa-clock subsection-icon pending" *ngIf="!hasIncome()"></i>
                                    <span>Ingresos mensuales</span>
                                </div>
                                <div class="subsection-item" [class.completed]="hasPaymentMethodsCompleted()">
                                    <i class="fas fa-check-circle subsection-icon" *ngIf="hasPaymentMethodsCompleted()"></i>
                                    <i class="fas fa-clock subsection-icon pending" *ngIf="!hasPaymentMethodsCompleted()"></i>
                                    <span>Medios de pago</span>
                                    <button class="subsection-action" *ngIf="_auth.hasPermission('contactos.onboarding.editar_medios_pago')" (click)="editPaymentMethods()">
                                        <i class="fas fa-edit"></i>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <!-- Análisis de Aprobación Card -->
                        <div *ngIf="item?.code == 'ANALYSIS' && !loading_analysis && analysis_response" class="step-card completed expandable">
                            <div class="step-header" (click)="toggleStepExpansion('analysis')">
                                <div class="step-icon">
                                    <i class="fas fa-chart-bar"></i>
                                </div>
                                <div class="step-info">
                                    <h6 class="step-title">{{item.name}}</h6>
                                </div>
                                <div class="step-actions">
                                    <button class="action-btn primary" *ngIf="_auth.hasPermission('contactos.onboarding.aprobar_rechazar')" (click)="pocisionBottom(content2); $event.stopPropagation()">
                                        <i class="fas fa-eye"></i> Ver
                                    </button>
                                    <i class="fas fa-check-circle status-icon completed"></i>
                                    <i class="fas fa-chevron-down expand-icon" [class.rotated]="expandedSteps['analysis']"></i>
                                </div>
                            </div>

                            <div class="step-details" [class.expanded]="expandedSteps['analysis']">
                                <div class="flex flex-wrap gap-2 mt-3">
                                    <span class="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                                        <i class="fas fa-calendar-alt mr-1"></i>
                                        Fecha: {{analysis_response?.date | date: 'dd/MM/yyyy HH:mm:ss'}}
                                    </span>
                                    <span class="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                                        <i class="fas fa-info-circle mr-1"></i>
                                        Estatus: {{analysis_response?.showStatusValue}}
                                    </span>
                                    <span class="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium"
                                          [class.bg-green-100]="analysis_response?.approve_status == 'APPROVED'"
                                          [class.text-green-800]="analysis_response?.approve_status == 'APPROVED'"
                                          [class.bg-red-100]="analysis_response?.approve_status == 'REFUSED'"
                                          [class.text-red-800]="analysis_response?.approve_status == 'REFUSED'"
                                          [class.bg-yellow-100]="analysis_response?.approve_status == 'PENDING'"
                                          [class.text-yellow-800]="analysis_response?.approve_status == 'PENDING'">
                                        <i class="fas fa-check-circle mr-1" *ngIf="analysis_response?.approve_status == 'APPROVED'"></i>
                                        <i class="fas fa-times-circle mr-1" *ngIf="analysis_response?.approve_status == 'REFUSED'"></i>
                                        <i class="fas fa-clock mr-1" *ngIf="analysis_response?.approve_status == 'PENDING'"></i>
                                        Respuesta: {{analysis_response?.showStatusApprove}}
                                    </span>
                                </div>

                                <!-- Fila Fase 2: handler decisivo + política + fallback -->
                                <div class="flex flex-wrap gap-2 mt-3" *ngIf="getDecisiveApprovalItem() as decisive">
                                    <span class="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-800">
                                        <i class="fas fa-gavel mr-1"></i>
                                        Decisión por: {{ getDecisiveHandlerLabel(decisive) }}
                                    </span>
                                    <span class="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-indigo-100 text-indigo-800"
                                          *ngIf="decisive?.policyModeAtDecision">
                                        <i class="fas fa-random mr-1"></i>
                                        Política: {{ getPolicyModeLabel(decisive.policyModeAtDecision) }}
                                    </span>
                                    <span class="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-amber-100 text-amber-800"
                                          *ngIf="decisive?.fallbackUsed">
                                        <i class="fas fa-exclamation-triangle mr-1"></i>
                                        Fallback utilizado
                                    </span>
                                </div>
                            </div>

                            <!-- Botones de acción manual -->
                            <div class="manual-actions" *ngIf="_auth.hasAccessOrProfile('contactos', ['OWNER']) && _auth.hasPermission('contactos.onboarding.aprobar_rechazar') && section_transactions?.length > 0 && !loading_analysis" [class.expanded]="expandedSteps['analysis']">
                                <button *ngIf="status_approved != 'APPROVED' || analysis_response?.transaction_status != 'COMPLETE'"
                                        type="button"
                                        class="action-btn success"
                                        (click)="manual_approve(person?.person?.code,true,'Aprobar')">
                                    <i class="fas fa-thumbs-up"></i> Aprobar Manual
                                </button>
                                <button *ngIf="status_approved != 'REFUSED' || analysis_response?.transaction_status != 'COMPLETE'"
                                        type="button"
                                        class="action-btn danger"
                                        (click)="manual_approve(person?.person?.code,false,'Rechazar')">
                                    <i class="fas fa-thumbs-down"></i> Rechazar Manual
                                </button>
                            </div>
                        </div>

                        <!-- Verificación de Identidad Card -->
                        <div *ngIf="item?.code == 'BIOMETRIC'" class="step-card expandable"
                             [class.completed]="manual_verification_list?.verified === true"
                             [class.in-progress]="inReview"
                             [class.pending]="section_transaction[item?.code]?.condition != 'COMPLETE' && !inReview && !manual_verification_list"
                             [class.warning]="manual_verification_list?.verified === false">
                            <div class="step-header" (click)="toggleStepExpansion('biometric')">
                                <div class="step-icon">
                                    <i class="fas fa-fingerprint"></i>
                                </div>
                                <div class="step-info">
                                    <h6 class="step-title">{{item.name}}</h6>
                                    <span class="step-status completed" *ngIf="manual_verification_list?.verified === true">Completado</span>
                                    <span class="step-status in-progress" *ngIf="inReview">En Revisión</span>
                                    <span class="step-status pending" *ngIf="section_transaction[item?.code]?.condition != 'COMPLETE' && !inReview && !manual_verification_list">Pendiente</span>
                                    <span class="step-status warning" *ngIf="manual_verification_list?.verified === false">Rechazado</span>
                                </div>
                                <div class="step-actions">
                                    <span class="biometric-badge" *ngIf="!loading && section_transaction && person?.person && biometria_data?.person?.person_customer?.biometric_enabled">
                                        <i class="fas fa-shield-alt"></i> Habilitada
                                    </span>
                                    <button class="action-btn primary" *ngIf="_auth.hasPermission('contactos.onboarding.read')" (click)="pocisionBottomBiometric(content3); $event.stopPropagation()">
                                        <i class="fas fa-eye"></i> {{inReview ? 'Revisar' : 'Ver'}}
                                    </button>
                                    <i class="fas fa-clock status-icon in-progress" *ngIf="inReview"></i>
                                    <i class="fas fa-exclamation-triangle status-icon warning" *ngIf="manual_verification_list?.verified === false"></i>
                                    <i class="fas fa-check-circle status-icon completed" *ngIf="manual_verification_list?.verified === true"></i>
                                    <i class="fas fa-chevron-down expand-icon" [class.rotated]="expandedSteps['biometric']"></i>
                                </div>
                            </div>

                            <!-- Subsecciones de biometría -->
                            <div class="step-subsections" [class.expanded]="expandedSteps['biometric']">
                                <div class="subsection-item" [class.completed]="person?.person?.file_selfie">
                                    <i class="fas fa-check-circle subsection-icon" *ngIf="person?.person?.file_selfie"></i>
                                    <i class="fas fa-clock subsection-icon pending" *ngIf="!person?.person?.file_selfie"></i>
                                    <span>Selfie</span>
                                    <div class="subsection-actions">
                                        <button class="subsection-action" *ngIf="_auth.hasPermission('contactos.onboarding.editar_selfie')" (click)="setBiometria('SELFIE')">
                                            <i class="fas fa-edit"></i>
                                        </button>
                                        <button class="subsection-action" *ngIf="_auth.hasPermission('contactos.onboarding.read') && person?.person?.file_selfie" (click)="pocisionBottomSelfie(contentSelfie)">
                                            <i class="fas fa-eye"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="subsection-item" [class.completed]="person?.person?.file_identity">
                                    <i class="fas fa-check-circle subsection-icon" *ngIf="person?.person?.file_identity"></i>
                                    <i class="fas fa-clock subsection-icon pending" *ngIf="!person?.person?.file_identity"></i>
                                    <span>Documento de identidad</span>
                                    <div class="subsection-actions">
                                        <button class="subsection-action" *ngIf="_auth.hasPermission('contactos.onboarding.editar_documento')" (click)="setBiometria('PHOTO_IDENTITY')">
                                            <i class="fas fa-edit"></i>
                                        </button>
                                        <button class="subsection-action" *ngIf="_auth.hasPermission('contactos.onboarding.read') && person?.person?.file_identity?.url" (click)="pocisionBottomSelfie(contentIdentity)">
                                            <i class="fas fa-eye"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="subsection-item" [class.completed]="section_transaction[item?.code]?.condition == 'COMPLETE'">
                                    <i class="fas fa-check-circle subsection-icon" *ngIf="section_transaction[item?.code]?.condition == 'COMPLETE'"></i>
                                    <i class="fas fa-clock subsection-icon pending" *ngIf="section_transaction[item?.code]?.condition != 'COMPLETE'"></i>
                                    <span>Verificación biométrica</span>
                                </div>
                            </div>
                        </div>

                        <!-- Buró Card -->
                        <div *ngIf="item?.code == 'BURO'" class="step-card" [class.completed]="!loading_buro && section_transaction[item?.code]?.condition == 'COMPLETE'" [class.pending]="section_transaction[item?.code]?.condition != 'COMPLETE'">
                            <div class="step-header">
                                <div class="step-icon">
                                    <i class="fas fa-search-dollar"></i>
                                </div>
                                <div class="step-info">
                                    <h6 class="step-title">{{item.name}}</h6>
                                    <span class="step-status" [class.completed]="!loading_buro && section_transaction[item?.code]?.condition == 'COMPLETE'" [class.pending]="section_transaction[item?.code]?.condition != 'COMPLETE'">
                                        {{section_transaction[item?.code]?.condition == 'COMPLETE' ? 'Completado' : 'Pendiente'}}
                                    </span>
                                </div>
                                <div class="step-actions">
                                    <button *ngIf="section_transaction[item?.code]?.condition != 'COMPLETE' && !loading_buro"
                                            class="action-btn primary"
                                            (click)="getDataBuro(person)">
                                        <i class="fas fa-play"></i> Consultar
                                    </button>
                                    <div *ngIf="loading_buro" class="loading-spinner">
                                        <i class="fas fa-spinner fa-spin"></i>
                                    </div>
                                    <i class="fas fa-check-circle status-icon completed" *ngIf="!loading_buro && section_transaction[item?.code]?.condition == 'COMPLETE'"></i>
                                    <i class="fas fa-clock status-icon pending" *ngIf="section_transaction[item?.code]?.condition != 'COMPLETE' && !loading_buro"></i>
                                </div>
                            </div>
                            <div class="step-details" *ngIf="!loading_buro && buro">
                                <div class="detail-item">
                                    <i class="fas fa-calendar"></i>
                                    <span>{{buro.fechaConsulta | date: 'dd/MM/yyyy h:mm:ss a'}}</span>
                                </div>
                            </div>
                        </div>

                    </div>

                    <!-- Psicométrico Card (si aplica) -->
                    <div *ngIf="status_approved == 'BURO_PSICOMETRICO'" class="step-card pending">
                        <div class="step-header">
                            <div class="step-icon">
                                <i class="fas fa-brain"></i>
                            </div>
                            <div class="step-info">
                                <h6 class="step-title">Psicométrico</h6>
                                <span class="step-status pending">Pendiente</span>
                            </div>
                            <div class="step-actions">
                                <button *ngIf="start_psicometrico && activatePsico"
                                        class="action-btn secondary"
                                        (click)="setStatus_psicometrico(false)">
                                    <i class="fas fa-pause"></i> Desactivar
                                </button>
                                <button *ngIf="start_psicometrico && !activatePsico"
                                        class="action-btn primary"
                                        (click)="setStatus_psicometrico(true)">
                                    <i class="fas fa-play"></i> Activar
                                </button>
                                <i class="fas fa-clock status-icon pending"></i>
                            </div>
                        </div>
                    </div>

                </div>

                <!-- No Section Data Message -->
                <div *ngIf="!hasSectionData()" class="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                    <div class="text-center py-8">
                        <i class="fas fa-info-circle text-gray-400 text-4xl mb-4"></i>
                        <h3 class="text-lg font-medium text-gray-900 mb-2">Cargando información del onboarding</h3>
                        <p class="text-gray-600">Los datos del proceso se están cargando...</p>
                    </div>
                </div>

                <!-- Loading State -->
                <ng-container *ngIf="loading_buro">
                    <div class="loading-section">
                        <div class="loading-spinner">
                            <i class="fas fa-spinner fa-spin"></i>
                        </div>
                        <p>Consultando información del buró...</p>
                    </div>
                </ng-container>

            </ng-container>

            <!-- Error States -->
            <div class="error-state" *ngIf="!loading && !person?.person">
                <i class="fas fa-user-slash"></i>
                <h3>Usuario no encontrado</h3>
                <p>No se encontró persona con este ID: {{queryParams?.code}}</p>
            </div>

        </div>
    </div>
</div>